export default "__VITE_ASSET__CEF51b7n__"